import { Heart } from "lucide-react";

const WEEKDAYS = ["ორშ", "სამ", "ოთხ", "ხუთ", "პარ", "შაბ", "კვი"];
const LEADING_BLANKS = 6;
const DAYS = Array.from({ length: 30 }, (_, i) => i + 1);
const WEDDING_DAY = 17;

export default function CalendarSection() {
  return (
    <section data-testid="wedding-calendar-section" className="text-center">
      <p className="eyebrow mb-2">ჩვენი ქორწილის დღე</p>
      <h2 className="font-display text-lg uppercase tracking-[0.3em] text-[#292524]">
        ნოემბერი <span className="gold-text">2026</span>
      </h2>

      <div className="gold-frame mx-auto mt-6 max-w-[310px] bg-white px-4 py-5">
        <div className="mb-2 grid grid-cols-7">
          {WEEKDAYS.map((d) => (
            <span
              key={d}
              className="py-1 text-[9px] font-semibold uppercase tracking-wider text-[#A1A1AA]"
            >
              {d}
            </span>
          ))}
        </div>

        <div className="grid grid-cols-7 gap-y-1">
          {Array.from({ length: LEADING_BLANKS }).map((_, i) => (
            <span key={`blank-${i}`} />
          ))}
          {DAYS.map((day) =>
            day === WEDDING_DAY ? (
              <div
                key={day}
                data-testid="calendar-wedding-day"
                className="relative mx-auto flex h-9 w-9 -rotate-[10deg] items-center justify-center"
              >
                <Heart
                  className="absolute h-8 w-8 text-[#DC2626] drop-shadow-[0_3px_6px_rgba(220,38,38,0.45)]"
                  fill="currentColor"
                  strokeWidth={0}
                  aria-hidden="true"
                />
                <span className="relative pb-0.5 text-[11px] font-bold text-white">{day}</span>
              </div>
            ) : (
              <div
                key={day}
                className="mx-auto flex h-9 w-9 items-center justify-center text-sm text-[#57534E]"
              >
                {day}
              </div>
            ),
          )}
        </div>
      </div>

      <p className="font-editorial mt-4 text-base italic text-[#78716C]">სამშაბათი · 18:00</p>
    </section>
  );
}
